interface IUserStorageData {
  uuidUsuario: string;
  usuarioCpfCnpj?: string;
  nome?: string;
  roles: string[];
  recursos?: string[];
}

export const useUserPermissions = () => {
  const getUserData = (): IUserStorageData | null => {
    try {
      const userData = localStorage.getItem("@usuarioMapa");
      if (!userData) {
        console.warn("Nenhum dado de usuário encontrado no localStorage");
        return null;
      }
      const parsed = JSON.parse(userData) as IUserStorageData;

      return parsed;
    } catch (error) {
      console.error("Erro ao fazer parse do usuário do localStorage:", error);
      return null;
    }
  };

  const userStorageData = getUserData();

  const hasRole = (role: string): boolean => {
    const result = userStorageData?.roles?.includes(role) ?? false;

    return result;
  };

  const hasRecurso = (recurso: string): boolean => {
    const result = userStorageData?.recursos?.includes(recurso) ?? false;

    return result;
  };

  const isAdmin = (): boolean => {
    return hasRole("ROLE_ADMIN");
  };

  const canResetPassword = (): boolean => {
    return hasRecurso("REDEFINIR_SENHA");
  };

  const hasAnyRole = (roles: string[]): boolean => {
    return roles.some((role) => hasRole(role));
  };

  const hasAnyRecurso = (recursos: string[]): boolean => {
    return recursos.some((recurso) => hasRecurso(recurso));
  };

  const hasAllRoles = (roles: string[]): boolean => {
    return roles.every((role) => hasRole(role));
  };

  const hasAllRecursos = (recursos: string[]): boolean => {
    return recursos.every((recurso) => hasRecurso(recurso));
  };

  return {
    userStorageData,
    hasRole,
    hasRecurso,
    isAdmin,
    canResetPassword,
    hasAnyRole,
    hasAnyRecurso,
    hasAllRoles,
    hasAllRecursos,
  };
};
